import * as clipboard from 'clipboard-polyfill';

export default {
  async copy(content, asHTML = false) {
    if (asHTML) {
      // https://github.com/lgarron/clipboard-polyfill
      const item = new clipboard.ClipboardItem({
        'text/html': new Blob(
          [content],
          {type: 'text/html'},
        ),
        'text/plain': new Blob(
          [content],
          {type: 'text/plain'},
        ),
      })
      await clipboard.write([item]);
      return content;
    } else {
      await clipboard.writeText(content);
      return content;
    }
  },
}
